var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_x30_6.Bold",
    fill: "white",
    d: "m403.321 235.911c16.996-20.761 27.479-46.08 30.134-72.779 8.236-85.157-58.583-157.132-141.82-157.132h-225.424c-8.284 0-15 6.716-15 15v59.286c0 8.284 6.716 15 15 15h38.426v321.429h-38.426c-8.284 0-15 6.716-15 15v59.285c0 8.284 6.716 15 15 15h236.473c79.018 0 149.71-57.757 157.366-136.607 5.291-54.074-18.292-102.746-56.729-133.482zm-209.632-140.625h97.946c29.587 0 53.571 23.985 53.571 53.571s-23.985 53.571-53.571 53.571h-97.946zm97.946 321.428h-97.946v-125h97.946c34.518 0 62.5 27.982 62.5 62.5s-27.982 62.5-62.5 62.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterB);
export default __webpack_public_path__ + "static/media/letter-b.b213e10101c91d3dfcd40e45f5e93425.svg";
export { ForwardRef as ReactComponent };